<template>
  <div
    class="w-full h-100px text-center bg-hex-$portalPrimaryColor flex items-center justify-center"
  >
    <div class="h-48px text-hex-fff">
      <div class="whitespace-pre-wrap">{{ statement }}</div>
    </div>
  </div>
</template>

<script>
import { WorkbenchSettingApi } from '@wiz-api/workbench-std'

const workbenchSettingApi = new WorkbenchSettingApi()
export default {
  data() {
    return {
      statement: '',
    }
  },
  methods: {
    async getFooterSettings() {
      const [err, res] = await workbenchSettingApi.getWorkbenchSetting({ code: 'footer' })
      if (!err && res && res.config) {
        const setting = JSON.parse(res.config)
        this.statement = setting.description
      }
    },
  },
  created() {
    this.getFooterSettings()
  },
}
</script>

<style></style>
